// extracted by mini-css-extract-plugin
export default {"container":"TransfersFormLayout_container__14-XL","column":"TransfersFormLayout_column__A4flc","howToColumn":"TransfersFormLayout_howToColumn__J1xmb"};